import { flow, makeObservable } from 'mobx';
import { PasswordApi } from '../apis';

class PasswordStore {
    constructor(rootStore) {
        makeObservable(this, {
            forgetPassword: flow.bound,
            checkUuid: flow.bound,
            setPassword: flow.bound,
            setPasswordSync: flow.bound
        });
        this.rootStore = rootStore;
        this.api = new PasswordApi();
    }

    *forgetPassword(payload, cb) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.forgetPassword,
                payload
            );

            if (res?.ok) {
                cb()
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *checkUuid(payload) {
        try {
            // Return the full response so the screen can read the error message/flags
            // (e.g. isImport) when the link is expired. disableAlertError stays on.
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.checkUuid,
                payload,
                false,
                null,
                false,
                true
            );
            return res;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    *setPassword(payload) {
        const { password, passwordConfirm, uuid, isForgetPassword } = payload;

        const paramsIsForget = {
            'password': password,
            'passwordConfirm': passwordConfirm,
            'uuid': uuid,
            'isForgetPassword': true
        }
        const paramsIsSetPass = {
            'password': password,
            'passwordConfirm': passwordConfirm,
            'uuid': uuid
        }

        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.setPassword,
                isForgetPassword == true ? paramsIsForget : paramsIsSetPass
            );

            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *setPasswordSync(payload) {
        const { password, passwordConfirm, uuid, roleId, examCode } = payload;

        const paramsSetPassSync = {
            'password': password,
            'passwordConfirm': passwordConfirm,
            'uuid': uuid,
            'roleId': roleId,
            'examCode': examCode
        }

        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.setPasswordSync,
                paramsSetPassSync
            );

            if (res?.ok) {
                // return the payload ({ status }) so the screen can branch on 承認待ち; {} keeps it truthy.
                return res.data || {};
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }
}

export default PasswordStore;
